// The platform's default brand logo, stored as an uploadthing file key. Shown
// on any surface — the planner sidebar and the public storefront shell — when
// the active organization has not uploaded a custom logo. Single source of
// truth so both surfaces fall back to the same mark.
export const DEFAULT_LOGO_KEY =
  '7b602XnIvE4b8cERXYLzIiMYercQWsBfdxtjX79V3RqDNkOS';

/**
 * The organization's logo key: `settings.logoKey` (where the Organization
 * Configuration form saves it), then the legacy `logo_key` column, then the
 * platform default. XT's sidebar and the collab summary on both XT and the
 * agent portal resolve it here, so they show the same logo.
 */
export const resolveOrgLogoKey = (org: {
  settings?: unknown;
  logoKey?: string | null;
}): string => {
  const settings =
    org.settings && typeof org.settings === 'object'
      ? (org.settings as Record<string, unknown>)
      : null;
  const fromSettings =
    typeof settings?.logoKey === 'string' && settings.logoKey.trim()
      ? settings.logoKey.trim()
      : null;
  return fromSettings ?? (org.logoKey?.trim() || DEFAULT_LOGO_KEY);
};
